import { NavigateFn } from "@reach/router";
import * as React from "react";
import { connect } from "react-redux";
import { Users } from "../../../just-in-types";
import { Routes } from "../../../just-in-types";
import {
  GetHasUserPaidToday,
  getHasUserPaidToday,
  navigateToNext,
  NavigateToNext,
  setUserValue,
  SetUserValue,
  UserValue,
} from "../store/actions";
import { IState } from "../store/reducers";
import { IStrings } from "../store/reducers/strings";
import LoaderButton from "./LoaderButton";
interface INextButtonOwnProps {
  bg: string;
  disabled: boolean;
  label?: string;
  skipToEnd?: boolean;
  name: UserValue["name"] | null;
  setNextBtnValidity?:any;
  value: UserValue["value"] | null;
}

interface INextButtonDispatchProps {
  onGetHasUserPaidToday: GetHasUserPaidToday;
  onNavigateToNext: NavigateToNext;
  onSetUserValue: SetUserValue;
}

interface INextButtonStateProps {
  businessId: string;
  languageStrings: IStrings;
  navigate: NavigateFn;
  rootPath: string;
  routes: Routes.RoutesObject;
  siteId: string;
  sitePath: string;
  updating: boolean;
  user: Users.User;
}

type NextButtonProps = INextButtonOwnProps &
  INextButtonDispatchProps &
  INextButtonStateProps;

interface INextButtonState {
  loading: boolean;
}

class NextButton extends React.Component<NextButtonProps, INextButtonState> {
  public state = {
    loading: false,
  };

  public handleClick = async () => {
    const {
      businessId,
      name,
      navigate,
      onGetHasUserPaidToday,
      onNavigateToNext,
      onSetUserValue,
      rootPath,
      routes: {
        signature: { waiverText, waiverTextEs },
      },
      siteId,
      sitePath,
      skipToEnd,
      updating,
      user,
      value,
    } = this.props;

    this.setState({ loading: true });


    if(this.props.setNextBtnValidity){
      this.props.setNextBtnValidity(true);
    }

    if (name && value) {
      onSetUserValue({ name, value }, user.mobile, businessId);
    }
    if (skipToEnd) {
      navigate(`${rootPath}/thanks`);
      this.setState({ loading: false });
    } else if (updating) {
      navigate(`${rootPath}/thanks`);
      this.setState({ loading: false });
    } else {
      if (name === "signature" && user.mobile !== "6028181729") {
        console.log("next button fired has user paid");
        await onGetHasUserPaidToday(
          user.mobile,
          businessId,
          siteId,
          sitePath,
          user.mugshot,
          user.signature,
          user.language === "eng" ? waiverText : waiverTextEs
        );
      }
      this.setState({ loading: false });
      onNavigateToNext();
    }
  };

  public render() {
    const { bg, disabled, label, languageStrings, updating } = this.props;
    const { loading } = this.state;
    const innerText = label
      ? label
      : updating
      ? languageStrings.update
      : languageStrings.next;

    return (
      <LoaderButton
        bg={bg}
        disabled={disabled}
        loading={loading}
        onClick={this.handleClick}
      >
        {innerText}
      </LoaderButton>
    );
  }
}

const mapStateToProps = ({
  router: {
    businessId,
    languageStrings,
    navigate,
    routes,
    siteId,
    sitePath,
    rootPath,
  },
  userTemp: { updating },
  user,
}: IState) => ({
  businessId,
  languageStrings,
  navigate,
  rootPath,
  routes,
  siteId,
  sitePath,
  updating,
  user,
});

const mapDispatchToProps = {
  onGetHasUserPaidToday: getHasUserPaidToday,
  onNavigateToNext: navigateToNext,
  onSetUserValue: setUserValue,
};

export default connect<
  INextButtonStateProps,
  INextButtonDispatchProps,
  INextButtonOwnProps
>(
  mapStateToProps,
  mapDispatchToProps
)(NextButton);



// WEBPACK FOOTER //
// ./src/components/NextButton.tsx